import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

/** Shared header-cell style for the geo-debug bottom-panel tables. */
export const headerCellSx: SxProps<Theme> = {
  fontWeight: 600,
  backgroundColor: (theme) => theme.semantic.surfaceSunken,
  borderBottom: (theme) => `2px solid ${theme.palette.divider}`,
};
